<div class="progress-spinner">
  <mat-card class="loader-mat-card">
    <div class="loader-msg">Loading...</div>
    <mat-spinner [diameter]="70"></mat-spinner>
  </mat-card>
</div>
